// Link preview attached to a BtSlimMessage. Engines project the raw
// WAWeb `Msg.linkPreview` (chrome) or baileys preview metadata to this
// slim shape at the handler boundary. The raw WAWeb shape lives inside
// the chrome extension per #74.
//
// `canonicalUrl` + `matchedText` keep WAWeb's naming on the wire; the
// public `/v1` mapper translates to `canonical_url` / `matched_text`.
//
// NOT the same as the WRITE-side / persisted `BtUserMessageLinkPreview`
// (lives in schemas/bt/user-message.ts) which uses `.url` and lives on
// the userMessages doc.

import { z } from 'zod';

export const BtSlimLinkPreviewSchema = z.object({
  title: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  matchedText: z.string().nullable().optional(),
  canonicalUrl: z.string().nullable().optional(),
  thumbnail: z.string().nullable().optional(),
});
export type BtSlimLinkPreview = z.infer<typeof BtSlimLinkPreviewSchema>;
